import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import { USAGE_REPORT_FAILED,USAGE_REPORT_SUCCESS } from "../Actions/ReportsActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* usageReportSaga(action:any):unknown{
    try {
        const response = yield call(axios.post,'usageReport',action.payload)
        const { 
            data,
            status
        } = response
        if(status ===200){
            yield put({type:USAGE_REPORT_SUCCESS,payload:data})
            yield put({type:TOAST_SHOW,payload:{ message: 'Usage Report fetched successfully', severity: 'Success', show: true }})
        }
    } catch (error) { 
        yield put({type:USAGE_REPORT_FAILED})
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}